<template>
    <div class="notifications">
        <div class="notifications-left" v-if="getErrors">
            <transition name="fade" v-for="(error, index) in getErrors" :key="index">
                <div class="notifications-container error">
                    <!-- <div class="icon-close" @click="$store.dispatch('deleteError', error)"></div> -->
                    <p>{{ error.message }}</p>
                </div>
            </transition>
        </div>
        <div class="notifications-right" v-if="getNotifications">
            <transition name="fade" v-for="(notification, index) in getNotifications" :key="index">
                <div class="notifications-container">
                    <div class="icon-close" @click="$store.dispatch('deleteNotification', notification)"></div>
                    <p v-html="notification.message"></p>
                </div>
            </transition>
        </div>
        <div class="notifications-right" v-if="getScores">
            <transition name="fade" v-for="(score, index) in getScores" :key="index">
                <GrouUp :score="score" />
            </transition>
        </div>
        <div class="notifications-right" v-if="getMessages">
            <transition name="fade" v-for="(message, index) in getMessages" :key="index">
                <div class="notifications-container" v-if="mayShow(message)" @click="openChat(message)">
                    <div class="icon-close" @click="$store.dispatch('deleteMessage', message)"></div>
                    <p class="notifications-container__title">{{message.user.firstname + ' ' + message.user.lastname}}</p>
                    <p v-html="message.message"></p>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Notifications',
    components: {
        GrouUp: () => import('./GrowUp.vue')
    },
    computed: {
        getErrors () {
            return this.$store.getters.getErrors
        },
        getMessages () {
            return this.$store.getters.getMessages
        },
        getNotifications () {
            return this.$store.getters.getNotifications
        },
        getScores () {
            return this.$store.getters.getScores
        },
        getUser () {
            return this.$store.getters.getAuthUser
        }
    },
    methods: {
        openChat(message) {
            this.$router.push({name: 'chat', params: {hash: message.chat + '&' + message.chat_hash}})
        },
        mayShow(message) {
            let user = this.getUser;
            let muted = user.muted_chats ? user.muted_chats.find(item => item === message.chat) : null;
            return user.id !== message.user.id && !muted ? true : false
        }
    }
}
</script>
<style lang="stylus">
.notifications
    position fixed
    right 0
    top 0
    left 0
    bottom 0
    pointer-events none
    z-index 20

    &-left
        position absolute
        left 0
        bottom 10px
        padding 30px
        +to-width(640px)
            bottom 70px
        +to-width(540px)
            width 100%
            padding 30px 10px
    
    &-right
        position absolute
        right 0
        bottom 10px
        padding 30px
        +to-width(640px)
            bottom 70px
        +to-width(540px)
            width 100%
            padding 30px 10px
            
    &-container
        width 300px
        padding 25px
        pointer-events all
        border-radius 15px
        background-color white
        color #000
        font-size 14px
        font-weight 500
        line-height 20px
        margin-top 6px
        transition opacity .5s
        animation fadeinup 0.3s linear
        box-shadow 0 0 18px #eaeaea
        position relative
        +to-width(540px)
            width 100%
        &.error
            background-color #fb3434c9
            box-shadow 0 0 18px #fb3434c9
            color white
        span
            font-size 16px

        &__title
            font-size 12px
            margin-bottom 10px
            color $blue
    


</style>